export interface SynchroFormData {
  [id: string]: SynchroDirection
}

export enum SynchroDirection {
  SRC1_TO_SRC2 = 10,
  SRC2_TO_SRC1 = 20,
}

export type SynchroHistory = {
  dateChg: string,
  label: string,
  oldValue: string,
  newValue: string,
  applyBy: string,
  src: string
}

export enum SyncState {
  OK = 'OK',
  DIFF = 'DIFF',
  OTHER_OWNER = 'OTHER_OWNER',
  MISSING = 'MISSING',
  TOO_MANY = 'TOO_MANY',
  DISABLED = 'DISABLED',
}

export enum SynchroType {
  COMPANIES = 'companies',
  PERSONS = 'persons',
  PRODUCT = 'product',
  COURSE = 'course',
  LOCATION = 'location',
  SESSIONS = 'session',
}
